import React from 'react';
import SunIcon from 'components/atoms/icons/sun-icon';
import BrokenCloudsIcon from 'components/atoms/icons/broken-clouds-icon';
import FewCloudsIcon from 'components/atoms/icons/few-clouds-icon';
import ScatteredCloudsIcon from 'components/atoms/icons/scattered-clouds-icon';
import ShowerRainIcon from 'components/atoms/icons/shower-rain-icon';
import MistIcon from 'components/atoms/icons/mist-icon';
import RainIcon from 'components/atoms/icons/rain-icon';
import WindIcon from 'components/atoms/icons/wind-icon';
import ThunderstormIcon from 'components/atoms/icons/thunderstorm-icon';
import SnowIcon from 'components/atoms/icons/snow-icon';
import classNames from 'classnames';
import TemperatureIcon from 'components/atoms/icons/temperature-icon';

import s from './styles.module.scss';

import type { WeatherIconType } from 'infrastructure/interfaces';

const weatherIconMap: Record<WeatherIconType, React.FC<any>> = {
  Sunny: SunIcon,
  'Mostly Sunny': SunIcon,
  'Partly Sunny': FewCloudsIcon,
  'Intermittent Clouds': ScatteredCloudsIcon,
  'Hazy Sunshine': MistIcon,
  'Mostly Cloudy': BrokenCloudsIcon,
  Cloudy: BrokenCloudsIcon,
  'Dreary (Overcast)': BrokenCloudsIcon,
  Fog: MistIcon,
  Showers: ShowerRainIcon,
  'Mostly Cloudy w/ Showers': ShowerRainIcon,
  'Partly Sunny w/ Showers': ShowerRainIcon,
  'T-Storms': ThunderstormIcon,
  'Mostly Cloudy w/ T-Storms': ThunderstormIcon,
  'Partly Sunny w/ T-Storms': ThunderstormIcon,
  Rain: RainIcon,
  Flurries: SnowIcon,
  'Mostly Cloudy w/ Flurries': SnowIcon,
  'Partly Sunny w/ Flurries': SnowIcon,
  Snow: SnowIcon,
  'Mostly Cloudy w/ Snow': SnowIcon,
  Ice: SnowIcon,
  Sleet: SnowIcon,
  'Freezing Rain': RainIcon,
  'Rain and Snow': SnowIcon,
  Hot: SunIcon,
  Cold: SnowIcon,
  Windy: WindIcon,
  Clear: SunIcon,
  'Mostly Clear': SunIcon,
  'Hazy Moonlight': MistIcon,
  'Partly Cloudy': FewCloudsIcon,
  'Partly Cloudy w/ Showers': ShowerRainIcon,
  'Partly Cloudy w/ T-Storms': ThunderstormIcon,
};

interface IProps {
  type: WeatherIconType;
  className?: string;
}

const WeatherIcon: React.FC<IProps> = ({ type, className }) => {
  const trimmedName = type.trim();
  const nameKey = Object.keys(weatherIconMap).find(
    (key) => trimmedName.toLowerCase() === key.toLowerCase(),
  );

  const Icon = nameKey
    ? weatherIconMap[nameKey as WeatherIconType]
    : TemperatureIcon;
  return <Icon className={classNames(s.icon, className)} />;
};

export default WeatherIcon;
